import { IScope } from 'angular'
import { CASH_MOVEMENT_TYPES } from '../../../constants'
import { CashMovementsManager } from '../../../managers/cash-movements-manager'
import { RegisterManager } from '../../../managers/register-manager'

/**
 * Controller for the set-cash-float-form component.
 *
 * @class SetCashFloatFormController
 */
export class SetCashFloatFormController {
  public cashFloatSettings: $TSFixMe
  public currencySymbol: $TSFixMe
  public vendNumberOptions: $TSFixMe
  public form: $TSFixMe

  constructor(
    private $scope: IScope,
    private registerManager: RegisterManager,
    public cashMovementsManager: CashMovementsManager
  ) {
    'ngInject'
    this.cashFloatSettings = {
      amount: null,
      note: null,
      type: CASH_MOVEMENT_TYPES.OPENING_CASH_FLOAT,
    }
    this._setCashFloatNumberOptions()
    this.registerManager.on(
      'activeOutletChange',
      this._setCashFloatNumberOptions,
      this
    )
  }

  public $onDestroy() {
    this.registerManager.off(
      'activeOutletChange',
      this._setCashFloatNumberOptions
    )
  }

  /**
   * Set the vend number options for the cash float.
   *
   * @private
   * @method _setCashFloatNumberOptions
   */
  private _setCashFloatNumberOptions() {
    const activeOutlet = this.registerManager.getActiveOutlet()
    this.currencySymbol = activeOutlet && activeOutlet.currency_symbol

    this.vendNumberOptions = {
      min: 0,
      allowedPrefix: this.currencySymbol,
      allowEmpty: true,
      decimalPlaces: 2,
    }
  }

  /**
   * Update the cash float setting notes.
   *
   * @methods updateNote
   */
  public updateNote = (note: string) => {
    this.cashFloatSettings = {
      ...this.cashFloatSettings,
      note,
    }
  }

  /**
   * Update the form validity within a new digest cycle.
   *
   * @methods setValid
   */
  public setFormValidity = (valid: boolean) => {
    this.$scope.$apply(() => {
      this.form.$setValidity('note', valid)
    })
  }
}
